import { render } from "./ForumsCategory.vue?vue&type=template&id=d9c72310"
import script from "./ForumsCategory.vue?vue&type=script&lang=js"
export * from "./ForumsCategory.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/web-frontend-dev/web-frontend-dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__